import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { SanitizedTextField } from './SanitizedTextField/SanitizedTextField';
import {
  validateSanitizedTextField,
  sanitizedTextFieldWithOptionsSchema,
} from './SanitizedTextField/sanitizedTextField.validation';

export const SanitizedTextFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'SanitizedTextField',
    component: SanitizedTextField,
    schema: sanitizedTextFieldWithOptionsSchema,
    validation: (value, validation, context) => {
      const errors = validateSanitizedTextField(value, context);
      errors.forEach(error => validation.addError(error));
    },
  }),
);

// Export all field extensions as an array for easy registration
export const scaffolderFieldExtensions = [SanitizedTextFieldExtension];
